import React, { useEffect, useState } from "react";
import * as Mui from "@mui/material";
import { useSelector } from "react-redux";
import { ArrowCircleLeft, ArrowCircleRight } from "@mui/icons-material";
import { themes } from "services/constants";
import sessionHandling from "services/utils/notificationUtils";
import { BackArrow } from "components/CustomComponents/BackArrow";
import { showToast } from "services/utils/Status";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import { CustomButton } from "components/CustomComponents/CustomButton";
import { useForm } from "react-hook-form";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { useFetch } from "services/hooks/useFetch";
import dayjs from "dayjs";
export const MoveLeaveGroup = ({
  setMoveScreen,
  setFetchUserDetails,
  companyDetails,
}) => {
  const {
    register,
    reset,
    watch,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onBlur" });
  const { domain, token, userDetails } = useSelector(
    (state) => state.tokenReducer
  );

  const [companyName, setCompanyName] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [oldLeaveGroupName, setOldLeaveGroupName] = useState("");
  const [leftSideEmployee, setLeftSideEmployee] = useState([]);
  const [rightSideEmployee, setRightSideEmployee] = useState([]);
  const [leftChecked, setLeftChecked] = useState(false);
  const [rightChecked, setRightChecked] = useState(false);
  const [effectiveFrom, setEffectiveFrom] = useState(dayjs());
  const [effectiveFromError, setEffectiveFromError] = useState(false);
  const [trigger, setTrigger] = useState(true);
  const { result: leaveGroupArray } = useFetch(`${domain}leave-group-new/`);
  const oldLeaveGoupId = watch("old_leavegroup_id");
  const newLeaveGroupId = watch("new_leave_group_id");
  const [tableHeight, setTableHeight] = useState(
    window.innerHeight < 700
      ? window.innerHeight * 0.4
      : window.innerHeight * 0.6
  );

  useEffect(() => {
    if (
      leaveGroupArray?.length !== 0 &&
      companyDetails?.length !== 0 &&
      trigger
    ) {
      setCompanyId(companyDetails[0]?.id);
      setValue("old_leavegroup_id", leaveGroupArray[0]?.id);
      setCompanyName(companyDetails[0]?.companyname);
      setOldLeaveGroupName(leaveGroupArray[0]?.name);
      setValue("company_name", companyDetails[0]?.companyname);
      setValue("old_leave_group", leaveGroupArray[0]?.name);
      setTrigger(false);
    }
  }, [companyDetails, leaveGroupArray, setValue, trigger]);

  useEffect(() => {
    const updateHeight = () => {
      if (window.innerHeight < 700) {
        setTableHeight(window.innerHeight * 0.43);
      } else {
        setTableHeight(window.innerHeight * 0.6);
      }
    };

    window.addEventListener("resize", updateHeight);

    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  const onSubmit = async (data) => {
    if (
      rightSideEmployee.length !== 0 &&
      effectiveFrom &&
      effectiveFrom.toString() !== "Invalid Date"
    ) {
      let userId = [];
      rightSideEmployee.forEach((element) => {
        userId.push(element?.user_id);
      });
      setEffectiveFromError(false);
      try {
        const response = await fetch(`${domain}moveleavegroup-assignment/`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
          body: JSON.stringify({
            target_leavegroup_id: newLeaveGroupId,
            user_id: userId,
            effective_from: effectiveFrom.format("YYYY-MM-DD"),
          }),
        });
        const res = await response.json();
        if (response.ok) {
          showToast("success", res.message);
          setFetchUserDetails(true);
          setMoveScreen(false);
          reset();
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    } else {
      if (effectiveFrom && effectiveFrom.toString() !== "Invalid Date") {
        showToast("error", "Select atleast one user");
      } else {
        setEffectiveFromError(true);
      }
    }
  };

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await fetch(
          `${domain}leavegroup-assignment/?company_id=${companyId}&leave_group_id=${oldLeaveGoupId}&status=dropdown&user_id=${userDetails?.id}`,

          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          let checkKey = res.map((data) => ({
            ...data,
            checked: false,
          }));
          setLeftSideEmployee(checkKey);
          setOldLeaveGroupName(checkKey[0]?.leave_group_name);
          setCompanyName(checkKey[0]?.company_name);
          setRightSideEmployee([]);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    };

    if (companyId && oldLeaveGoupId) {
      fetchEmployees();
    }
  }, [companyId, domain, oldLeaveGoupId, token, userDetails?.id]);

  const handleToggleLeft = (value) => () => {
    setLeftChecked(false);
    setRightChecked(true);
    if (value.checked) {
      let updatedData = leftSideEmployee.map((data) => {
        if (data.user_id === value.user_id) {
          return {
            ...data,
            checked: false,
          };
        } else {
          return data;
        }
      });
      setLeftSideEmployee(updatedData);
    } else {
      let updatedData = leftSideEmployee.map((data) => {
        if (data.user_id === value.user_id) {
          return {
            ...data,
            checked: true,
          };
        } else {
          return data;
        }
      });
      setLeftSideEmployee(updatedData);
    }
  };

  const handleToggleRigh = (value) => () => {
    setLeftChecked(true);
    setRightChecked(false);
    let updatedData = rightSideEmployee.map((data) =>
      data.user_id === value.user_id
        ? { ...data, checked: !value.checked }
        : data
    );
    setRightSideEmployee(updatedData);
  };

  const handleCheckedRight = () => {
    const data = leftSideEmployee.filter((user) => {
      return user.checked === true;
    });
    const remaingData = leftSideEmployee.filter((user) => {
      return user.checked === false;
    });
    let updateAsFalse = data.map((users) => {
      return {
        ...users,
        checked: false,
      };
    });
    let updatedData = [...rightSideEmployee, ...updateAsFalse];
    setRightSideEmployee(updatedData);
    setLeftSideEmployee(remaingData);
    setLeftChecked(false);
    setRightChecked(false);
  };

  const handleCheckedLeft = () => {
    const data = rightSideEmployee.filter((user) => {
      return user.checked === true;
    });
    const remaingData = rightSideEmployee.filter((user) => {
      return user.checked === false;
    });
    let updateAsFalse = data.map((users) => {
      return {
        ...users,
        checked: false,
      };
    });
    let updatedData = [...leftSideEmployee, ...updateAsFalse];
    setLeftSideEmployee(updatedData);
    setRightSideEmployee(remaingData);
    setLeftChecked(false);
    setRightChecked(false);
  };

  const updateCompanyName = (event, data) => {
    if (data) {
      setCompanyId(data?.id);
      setCompanyName(data?.companyname);
      setValue("company_name", data?.label);
    }
  };

  const oldLeaveGroup = (event, data) => {
    if (data) {
      setOldLeaveGroupName(data?.name);
      setValue("old_leavegroup_id", data?.id);
    }
  };

  const newLeaveGroup = (event, data) => {
    if (data) {
      setValue("new_leave_group", data?.name);
      setValue("new_leave_group_id", data?.id);
    } else {
      setValue("new_leave_group", "");
    }
  };

  const handleEffectiveFrom = (value) => {
    setEffectiveFrom(value);
  };

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Mui.Grid container xs={12} spacing={2} sx={{ paddingTop: 2 }}>
          <Mui.Grid xs={0.4} sx={{ paddingLeft: 1 }}>
            <BackArrow
              actionFunction={() => {
                setMoveScreen(false);
              }}
            />
          </Mui.Grid>
          <Mui.Grid xs={6}>
            <Mui.Typography
              sx={{
                fontSize: 24,
                fontWeight: 700,
                paddingTop: 1,
                paddingLeft: 0.5,
              }}
            >
              LMS / Assignment / Move
            </Mui.Typography>
          </Mui.Grid>
          <Mui.Grid item xs={2.5} sx={{ paddingTop: 2 }}>
            <Mui.Typography sx={{ fontWeight: "bold", marginBottom: 1 }}>
              Company
            </Mui.Typography>
            <CustomAutoComplete
              dataList={companyDetails
                .filter((obj) => obj.companyname !== "All Companies")
                .map((obj) => ({
                  ...obj,
                  label: obj.companyname,
                }))}
              rules={{
                ...register("company_name", {
                  required: "Company name is required",
                }),
              }}
              selectedValue={companyName}
              updateDataFunction={updateCompanyName}
              placeHolder="Select company name"
              errorMessage={
                errors?.company_name?.message
                  ? errors?.company_name?.message
                  : ""
              }
              textBoxError={errors.company_name ? true : false}
            />
          </Mui.Grid>

          <Mui.Grid item xs={2.5}>
            <Mui.Typography sx={{ fontWeight: "bold" }}>
              Effective From
            </Mui.Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker"]}>
                <DatePicker
                  size="small"
                  slotProps={{ textField: { size: "small" } }}
                  sx={{ minWidth: "100%" }}
                  value={effectiveFrom}
                  minDate={dayjs()}
                  format="DD/MM/YYYY"
                  onChange={handleEffectiveFrom}
                  renderInput={(params) => (
                    <Mui.TextField {...params} size="small" />
                  )}
                />
              </DemoContainer>
            </LocalizationProvider>
            {effectiveFromError ? (
              <h6
                style={{
                  paddingTop: 2,
                  color: themes.helperTextColor,
                  fontSize: 12,
                }}
              >
                Effective from is required
              </h6>
            ) : null}
          </Mui.Grid>
        </Mui.Grid>

        <Mui.Grid container sx={{ mt: 1 }}>
          <Mui.Grid xs={1.4}></Mui.Grid>
          <Mui.Grid xs={5}>
            <Mui.Typography
              sx={{
                fontSize: 18,
                fontWeight: "bold",
              }}
            >
              Current Leave Group
            </Mui.Typography>
          </Mui.Grid>
          <Mui.Grid>
            <Mui.Typography
              sx={{
                fontSize: 18,
                fontWeight: "bold",
              }}
            >
              New Leave Group
            </Mui.Typography>
          </Mui.Grid>
        </Mui.Grid>

        <Mui.Grid
          container
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "Center",
            alignItems: "Center",
            paddingLeft: 13,
            paddingRight: 13,
          }}
        >
          <Mui.Grid
            container
            component={Mui.Paper}
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "Center",
              alignItems: "Center",
              padding: 2,
              backgroundColor: "#f7f5f6",
              maxHeight: tableHeight * 1.6,
            }}
          >
            <Mui.Grid item xs={12} sm={12} md={6} lg={5}>
              <>
                <Mui.Typography
                  sx={{
                    fontSize: 18,
                    fontWeight: "bold",
                  }}
                >
                  Leave Group
                </Mui.Typography>
                <Mui.Grid container sx={{ paddingTop: 0.5 }}>
                  <Mui.Grid xs={12}>
                    <CustomAutoComplete
                      dataList={leaveGroupArray
                        .filter((obj) => obj?.name !== watch("new_leave_group"))
                        .map((obj) => ({
                          ...obj,
                          label: obj?.name,
                        }))}
                      rules={{
                        ...register("old_leave_group", {
                          required: "Current Leave group is required",
                        }),
                      }}
                      selectedValue={oldLeaveGroupName}
                      updateDataFunction={oldLeaveGroup}
                      placeHolder="Select leave group"
                      errorMessage={
                        errors?.old_leave_group?.message
                          ? errors?.old_leave_group?.message
                          : ""
                      }
                      textBoxError={errors.old_leave_group ? true : false}
                    />
                  </Mui.Grid>
                </Mui.Grid>

                <Mui.FormControl fullWidth sx={{ paddingTop: 2 }}>
                  <Mui.Grid
                    sx={{
                      width: "100%",
                      bgcolor: "background.paper",
                    }}
                    component={Mui.Paper}
                  >
                    <Mui.Card>
                      <Mui.List
                        sx={{
                          width: "100%",
                          height: {
                            xs: 200,
                            sm: 300,
                            md: 300,
                            lg: tableHeight,
                          },
                          bgcolor: "background.paper",
                          overflow: "auto",
                        }}
                        dense
                        component="div"
                        role="list"
                      >
                        {leftSideEmployee.length === 0 ? (
                          <Mui.ListItem>
                            <Mui.Alert sx={{ width: "100%" }} severity="info">
                              No employees available under the leave group
                            </Mui.Alert>
                          </Mui.ListItem>
                        ) : (
                          leftSideEmployee.map((value) => {
                            const labelId = `transfer-list-all-item-${value.user_id}-label`;

                            return (
                              <Mui.ListItemButton
                                key={value.user_id}
                                role="listitem"
                                onClick={handleToggleLeft(value)}
                              >
                                <Mui.ListItemIcon>
                                  <Mui.Checkbox
                                    checked={value.checked}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                      "aria-labelledby": labelId,
                                    }}
                                  />
                                </Mui.ListItemIcon>
                                <Mui.ListItemAvatar>
                                  <Mui.Avatar
                                    alt={value?.user_name
                                      ?.charAt(0)
                                      .toUpperCase()}
                                    src={value?.image_url}
                                  />
                                </Mui.ListItemAvatar>
                                <Mui.ListItemText
                                  id={labelId}
                                  primary={`${value.user_name}`}
                                />
                              </Mui.ListItemButton>
                            );
                          })
                        )}
                      </Mui.List>
                    </Mui.Card>
                  </Mui.Grid>
                </Mui.FormControl>
              </>
            </Mui.Grid>
            <Mui.Grid item xs={12} sm={12} md={1.5} lg={1}>
              <Mui.Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                sx={{ height: "100%" }}
              >
                <Mui.IconButton
                  onClick={handleCheckedRight}
                  disabled={leftChecked.length === 0}
                  sx={{
                    textTransform: "capitalize",
                    color: themes.headLine,
                  }}
                  variant="contained"
                  size="medium"
                >
                  <ArrowCircleRight color={themes.headLine} fontSize="large" />
                </Mui.IconButton>
                <Mui.IconButton
                  onClick={handleCheckedLeft}
                  disabled={rightChecked.length === 0}
                  sx={{
                    textTransform: "capitalize",
                    color: themes.headLine,
                  }}
                  variant="contained"
                  size="medium"
                >
                  <ArrowCircleLeft color={themes.headLine} fontSize="large" />
                </Mui.IconButton>
              </Mui.Grid>
            </Mui.Grid>

            <Mui.Grid item xs={12} sm={12} md={6} lg={5}>
              <>
                <Mui.Typography
                  sx={{
                    fontSize: 18,
                    fontWeight: "bold",
                  }}
                >
                  Leave Group
                </Mui.Typography>
                <Mui.Grid container sx={{ paddingTop: 0.5 }}>
                  <Mui.Grid xs={12}>
                    <CustomAutoComplete
                      dataList={leaveGroupArray
                        .filter((obj) => obj.name !== oldLeaveGroupName)
                        .map((obj) => ({
                          ...obj,
                          label: obj.name,
                        }))}
                      rules={{
                        ...register("new_leave_group", {
                          required: "New leave group is required",
                        }),
                      }}
                      selectedValue={watch("new_leave_group")}
                      updateDataFunction={newLeaveGroup}
                      placeHolder="Select leave group"
                      errorMessage={
                        errors?.new_leave_group?.message
                          ? errors?.new_leave_group?.message
                          : ""
                      }
                      textBoxError={errors.new_leave_group ? true : false}
                    />
                  </Mui.Grid>
                </Mui.Grid>
                <Mui.FormControl fullWidth sx={{ paddingTop: 2 }}>
                  <Mui.Grid
                    sx={{
                      width: "100%",
                      bgcolor: "background.paper",
                    }}
                    component={Mui.Paper}
                  >
                    <Mui.Card>
                      <Mui.List
                        sx={{
                          width: "100%",
                          height: {
                            xs: 200,
                            sm: 300,
                            md: 300,
                            lg: tableHeight,
                          },
                          bgcolor: "background.paper",
                          overflow: "auto",
                        }}
                        dense
                        component="div"
                        role="list"
                      >
                        {rightSideEmployee.map((value) => {
                          const labelId = `transfer-list-all-item-${value.user_id}-label`;

                          return (
                            <Mui.ListItemButton
                              key={value.user_id}
                              role="listitem"
                              onClick={handleToggleRigh(value)}
                            >
                              <Mui.ListItemIcon>
                                <Mui.Checkbox
                                  checked={value.checked}
                                  tabIndex={-1}
                                  disableRipple
                                  inputProps={{
                                    "aria-labelledby": labelId,
                                  }}
                                />
                              </Mui.ListItemIcon>
                              <Mui.ListItemAvatar>
                                <Mui.Avatar
                                  alt={value?.user_name?.charAt(0)}
                                  src={value?.image_url}
                                />
                              </Mui.ListItemAvatar>
                              <Mui.ListItemText
                                id={labelId}
                                primary={`${value.user_name}`}
                              />
                            </Mui.ListItemButton>
                          );
                        })}
                      </Mui.List>
                    </Mui.Card>
                  </Mui.Grid>
                </Mui.FormControl>
              </>
            </Mui.Grid>
            <Mui.Grid container sx={{ mt: 2 }}>
              <Mui.Grid xs={window.innerHeight < 700 ? 8.6 : 9.9}></Mui.Grid>
              <CustomButton
                actionName="Cancel"
                typeName="button"
                actionFuntion={() => {
                  setMoveScreen(false);
                }}
              />
              &nbsp;&nbsp;
              <CustomButton actionName="Move" typeName="submit" />
            </Mui.Grid>
          </Mui.Grid>
        </Mui.Grid>
      </form>
    </React.Fragment>
  );
};
